<template>
  <el-dialog
    title="邀请他人审阅"
    :visible.sync="cooperVisi"
    width="40%"
    :before-close="handleClose"
  >
    <!-- 已邀请的协作人 -->
    <el-form
      v-if="darfPhoneList.length !== 0"
      style="margin-top: 10px"
      :model="dynamicValidateForm"
      ref="dynamicValidateForm"
      label-width="100px"
      size="small"
    >
      <el-form-item
        v-for="(item, i) of darfPhoneList"
        :label="`协作人${i + 1}:`"
        :key="item.i"
        label-width="100px"
        size="small"
      >
        <div class="item-sty">
          <el-input
            :value="item.mobilePhone"
            readonly
            :style="{ 'margin-right': '10px', width: inputWidth }"
          ></el-input>
          <el-input
            :value="item.userName"
            readonly
            :style="{ width: inputWidth }"
          ></el-input>
        </div>
      </el-form-item>
    </el-form>
    <!--  -->
    <el-form
      style="margin-top: 10px"
      :model="dynamicValidateForm"
      ref="dynamicValidateForm"
      label-width="100px"
      size="small"
    >
      <el-form-item
        v-for="(domain, index) in dynamicValidateForm.domains"
        label="添加协作人"
        :key="domain.key"
        :prop="'domains.' + index + '.mobile'"
        :rules="domain.r_mobile"
      >
        <div class="item-sty">
          <el-input
            v-model="domain.mobile"
            placeholder="协作人手机号"
            :style="{ 'margin-right': '10px', width: inputWidth }"
          ></el-input>
          <el-input
            v-model="domain.name"
            placeholder="协作人名称"
            :style="{ width: inputWidth }"
          ></el-input>
          <i class="el-icon-circle-plus-outline" @click="addDomain"></i>
          <i
            class="el-icon-delete"
            v-show="dynamicValidateForm.domains.length > 1"
            @click="removeDomain(domain)"
          ></i>
        </div>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="handleClose">取 消</el-button>
      <el-button
        type="primary"
        size="small"
        @click="submitForm('dynamicValidateForm')"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>
<script>
import {
  mobileOrEmail,
  identityNo,
  businessVal,
  personalName,
  mobile,
  happy
} from "@/assets/js/lib/valid-methods";

export default {
  props: {
    cooperVisi: Boolean,
    darfPhoneList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    // 这里存放数据
    return {
      inputWidth: '173px',
      dynamicValidateForm: {
        domains: [
          {
            key: Date.now(),
            mobile: "",
            name: '',
            r_mobile: [{ validator: mobile, trigger: "change" }]
          }
        ]
      }
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    submitForm (formName) {
      this.$refs[formName].validate(valid => {
        console.log("valid", valid);
        if (valid) {
          // 提交数据
          // 获取到上传的文件及附件。保存到vux中到协同页面
          const phoneList = this.dynamicValidateForm.domains.map(item => {
            return { mobile: item.mobile, name: item.name };
          });
          const mobiles = phoneList.map(item => {
            return item.mobile
          })
          let set = new Set(mobiles);
          if (set.size !== mobiles.length) return this.$message.error('请不要输入重复手机号码');
          this.$emit("saveAndJump", phoneList);
          this.resetForm(formName)
          this.handleClose();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm (formName) {
      const domains = this.dynamicValidateForm.domains;
      domains.forEach(ele => {
        ele.name = ''
      });
      this.$refs[formName].resetFields();
    },
    removeDomain (item) {
      var index = this.dynamicValidateForm.domains.indexOf(item);
      if (index !== -1) {
        this.dynamicValidateForm.domains.splice(index, 1);
      }
    },
    addDomain () {
      const domains = this.dynamicValidateForm.domains;
      if (domains.length == 10) return this.$message.warning('最多邀请 10 人参与审阅')
      domains.push({
        mobile: "",
        name: '',
        r_mobile: [{ validator: mobile, trigger: "change" }],
        key: Date.now()
      });
    },
    handleClose () {
      this.$emit("update:cooperVisi", false);
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () { },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () { }
};
</script>
<style lang="less" scoped>
.item-sty {
  display: flex;
  align-items: center;
}
.el-icon-delete,
.el-icon-circle-plus-outline {
  color: rgba(41, 2, 2, 0.45);
  cursor: pointer;
  font-size: 16px;
  margin: 0 5px;
  &:hover {
    color: #ec1c1c;
  }
}
</style>



// WEBPACK FOOTER //
// pages/initiation/components/cooperateWith/cooperPup.vue